// extracted by css-extract-rspack-plugin
export default {"root":"VmMeX35qOAnQwzsR","notificationBadge":"gEn469a3xx8u3qbD","separator":"HxBkrK4qX4sFtEQN","divider":"zGGyZvmeCzcF9gpc"};